import ProjectComponentTracker from '@/features/end-of-lease/components/ProjectComponentTracker';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/lease/projects/$projectId/components/$partNumber/page',
)({
    component: ProjectComponentTracker,
});
